export const SERVICENOW_ARCHITECTURE_PIPELINE = [
  {
    id: "cmdb-data-model",
    title: "CMDB & Data Model",
    icon: "database",
    color: "#22c55e",
    summary: "Every ServiceNow solution starts with accurate Configuration Items (CIs) and Relationships modeling what actually exists.",
    details: [
      "Configuration Items (CIs) — servers, applications, databases — live in cmdb_ci and its subclasses; CI Relationships (depends on / runs on) connect them for Impact Analysis.",
      "CSDM (Common Service Data Model) layers CIs into Foundation, Design, Build, Manage, and Consume domains so Business Services map cleanly onto the technical CIs beneath them.",
      "CIs are populated manually, via Discovery (automated scanning), or via a Service Graph Connector — inaccurate CMDB data breaks every downstream ITSM process.",
    ],
  },
  {
    id: "security-access",
    title: "Security & Access Control",
    icon: "fingerprint",
    color: "#4ade80",
    summary: "Access Control Lists (ACLs), Roles, and Data Policies control exactly who can see and change which records and fields.",
    details: [
      "ACLs define who (role/condition/script) can Create/Read/Write/Delete on a table or field — evaluated top-down, with field-level ACLs restricting sensitive data.",
      "Roles grant capabilities (e.g. 'itil,' 'admin') while Groups organize people — a user's Role determines what they can do, not just what team they're on.",
      "Instance hardening (MFA/SSO, IP allowlisting, Security Center review) protects the platform itself, layered on top of table/field-level ACLs.",
    ],
  },
  {
    id: "itsm-workflow",
    title: "ITSM Process & Flow Designer",
    icon: "zap",
    color: "#16a34a",
    summary: "Incident, Problem, Change, and Request processes are automated with Flow Designer — the modern no-code automation standard.",
    details: [
      "Incident restores service fast (Priority = Impact x Urgency, with Major Incident Management for high-severity outages); Problem finds root cause via Known Errors; Change controls risk via CAB review.",
      "Flow Designer (Trigger + Actions + Subflows) replaced the legacy Workflow Editor — Record-Triggered Flows fire on save, Screen Flows guide interactive data entry.",
      "Request Management fulfills Service Catalog orders through the REQ -> RITM -> Catalog Task chain, gated by Approval rules.",
    ],
  },
  {
    id: "scripting-dev",
    title: "Scripting & Application Development",
    icon: "layers",
    color: "#4ade80",
    summary: "When declarative tools hit their limits, Business Rules, Script Includes, and Scoped Applications take over.",
    details: [
      "Business Rules run server-side on database events; Client Scripts run in-browser for live UI feedback — never rely on Client Scripts alone for security.",
      "Script Includes are reusable server-side function libraries; GlideRecord is the standard API for querying/updating records.",
      "Scoped Applications (built in Studio, isolated by a unique prefix) package custom tables/logic/roles safely, separate from Global and other apps.",
    ],
  },
  {
    id: "integration",
    title: "Integration & APIs",
    icon: "bot",
    color: "#86efac",
    summary: "REST APIs, IntegrationHub Spokes, and Import Sets/Transform Maps connect ServiceNow to the outside world in both directions.",
    details: [
      "The Table API gives generic REST CRUD access to any table; Scripted REST APIs add custom logic when the Table API isn't flexible enough.",
      "IntegrationHub Spokes package pre-built Actions (Slack, Teams, etc.) for use inside any Flow, without hand-written HTTP callouts.",
      "Import Sets stage external data before Transform Maps map/coalesce it into real tables like cmdb_ci_computer — critical for bulk migrations.",
    ],
  },
  {
    id: "ai-automation",
    title: "AI & Now Assist",
    icon: "sparkles",
    color: "#34d399",
    summary: "Generative AI, Now Assist skill packs, and goal-driven AI Agents add summarization, drafting, and autonomous triage on top of the platform.",
    details: [
      "Now Assist Essentials (Summarization, Generative Text, Conversational Search) is the shared foundation persona packs (ITSM/CSM/Creator) build on.",
      "AI Agents are goal-driven, tool-using workers that can take multi-step autonomous actions — gated by a configurable confidence threshold before acting unsupervised.",
      "Predictive Intelligence (ML classification) and AI Search (semantic search) improve triage accuracy and Knowledge findability beyond keyword matching.",
    ],
  },
  {
    id: "deployment",
    title: "Deployment & DevOps",
    icon: "building",
    color: "#22c55e",
    summary: "Everything built above must move safely from a PDI/dev instance to Production via Update Sets or Git-based Source Control.",
    details: [
      "Update Sets capture configuration changes for cross-instance promotion — always work in a named, current Update Set, never Default.",
      "Source Control Integration links Scoped Applications to Git, enabling branching, PR review, and CI/CD-friendly deployment for active development teams.",
      "ATF (Automated Test Framework) provides no-code regression tests that catch breakage before/after upgrades or deployments.",
    ],
  },
];
